import { BaseSnapshot } from './base-snapshot';

export class VolumeSnapshot extends BaseSnapshot {
    constructor(json: any) {
        super(json);
    }
}
